import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { debounceTime, Subscription } from 'rxjs';
import { FormlyDynamicService } from '../formly-dynamic.service';
import moment from 'moment';
import { FilterService } from 'src/app/services/filter.service';
import { UserActivityService } from 'src/app/services/useractivity.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
  selector: 'app-formly-date-range',
  templateUrl: './formly-date-range.component.html',
  styleUrls: ['./formly-date-range.component.scss']
})
export class FormlyDateRangeComponent extends FieldType implements OnInit, OnDestroy {

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  minDate = new Date();
  maxDate = new Date();
  filterBadgeObj: any = {};
  isRestriction: any='yes';

  reqSubcription: Subscription[] = []
  
  override field: any
  
  cardName: any;
  
  fieldKey:any;
  currentField:any;
  templateOptions: any;
  label:any;
  labelProp:any;
  valueProp:any;
  dataSourceUrl:any;
  selectedType:any;
  mixPanelConfiguration = false;
  dashboardKey:any;
  compulsaryFilter = true;
  tabId = 0;
  moduleName:any;
  selectedDashboardKey:any;

  constructor(
    private formlyDynamicService: FormlyDynamicService,
    private filterService: FilterService,
    private userActivityService: UserActivityService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private dashboardService: DashboardService,
    private mixpanelService: MixpanelService
  ) { 
    super()
  }

  // fromDateProp
  // toDateProp
  // selectedFromDate
  // selectedDefaultFromDate


  // Selected Date
  // Uniq Key
  bookmarkId:any;
  queryFilterData:any;

  ngOnInit(): void {
    this.fieldKey = this.key as string;

    this.reqSubcription.push(this.route.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';
      this.bookmarkId = p?.['bk_mrk_key'] || undefined;
      
      if(this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
        this.queryFilterData = this.filterService.bookmarkFilterData;
      }


      this.route.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
        this.tabId = params["tab_id"];

        this.cardName = p["cardName"];
      });      
    }));

    // Filter Reset Method using Subject
    this.reqSubcription.push(this.filterService.formReset.subscribe((res: any) => {
      this.queryFilterData = {};
      // Find Selected Value
      let dbDate = this.formlyDynamicService.findSelectedDate(this.maxDate);

      if(!this.compulsaryFilter) {
        const dbDates = {
          start: null,
          end: null
        }
        this.range.patchValue(dbDates);
        
        let formlyDb = this.formlyDynamicService.setFormlyFormValue(this.templateOptions, dbDates);
        this.field.formControl?.setValue(formlyDb);

        // Set Badges
        this.formlyDynamicService.setBadges(this.fieldKey, dbDates,this.filterBadgeObj);
        
        const date = this.formlyDynamicService.findAllSelectedDate(dbDates, false);
        this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));

      } else {
        this.range.patchValue(dbDate);
        
        // Set Values
        let formlyDb = this.formlyDynamicService.setFormlyFormValue(this.templateOptions, dbDate);        
        this.field.formControl?.setValue(formlyDb);
        
        // Set Badges
        this.formlyDynamicService.setBadges(this.fieldKey, dbDate,this.filterBadgeObj);
        const date = this.formlyDynamicService.findAllSelectedDate(dbDate, true);
        this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
      }

    }), this.filterService.intractiveFilter.pipe(debounceTime(500)).subscribe((res: any) => {
              //  debugger
               if (this.field?.key ===  res.key &&  res.type == "D") {
                this.range.value.start = res.value.from_date;
                this.range.value.end = res.value.to_date;
                this.range.patchValue(this.range.value);
                this.endDateChanges();
               
               }
         
             }))

    
    this.currentField = this.field;
    this.templateOptions = this.field.templateOptions || {};
    this.label = this.templateOptions.label;
    this.dataSourceUrl = this.templateOptions.dataSourceUrl;
    
    this.labelProp = this.templateOptions.labelProp;
    this.valueProp = this.templateOptions.valueProp;
    // debugger
    this.compulsaryFilter = this.templateOptions?.compulsaryFilter == 'no' ? false : true;
    this.templateOptions["parentKey"] = this.templateOptions.parentKey ? this.templateOptions.parentKey : "";    
    this.mixPanelConfiguration = this.templateOptions.mixPanelConfiguration == 'yes' ? true : false;
    this.selectedDashboardKey = this.templateOptions.selectedDashboardKey || '';
    this.isRestriction = this.templateOptions.isRestriction;

    // Subscription of Time Cycle Widget
    this.reqSubcription.push(this.formlyDynamicService.timeCycleChanges.subscribe((res:any)=> {
      if(!res) return;
      this.selectedType = res;
      this.loadApiData(this.templateOptions.method || "POST", this.dataSourceUrl, this.templateOptions.parameter, this.model);
    }))

    if (this.currentField.parentKey != "") {
      (this.field.hooks as any).afterViewInit = (f: any) => {
        const parentControl = this.form.get(this.currentField.parentKey);
        parentControl?.valueChanges.subscribe((val: any) => {
          let selectedOption = this.model[this.fieldKey];

          let fndChild:any = this.filterService.globalFilterFields.find((res:any)=> this.fieldKey == res.parentKey)
          if(fndChild) {
            this.model[fndChild.key] = ''
          }

          if(this.fndParent()) {
            if (this.dataSourceUrl == "" && selectedOption) {
              let v = val.find((d: any) => d[this.valueProp] == selectedOption[this.valueProp])
              this.field.formControl?.setValue(v)
            } else {
              if(this.model[this.currentField.parentKey]) {
                this.loadApiData(this.templateOptions.method || "POST", this.dataSourceUrl, this.templateOptions.parameter, this.model);
              } else {
                this.model[this.fieldKey] = '';
              }
            }
          }
        })
      }
    }    
  }

  fndParent() {
    let data:any;
    if(this.model[this.currentField.parentKey].length) {
      data = this.model[this.currentField.parentKey].find((r:any)=> r[this.currentField.parentKey])
    } else if(this.isObjectNotArray(this.model[this.currentField.parentKey])) {
      data = this.model[this.currentField.parentKey][this.currentField.parentKey]
    } else if (this.model[this.currentField.parentKey]) {
    }

    return data
  }

  isObjectNotArray(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  loadApiData(method:string, url:string,parameter:string,data:any) {
    if(this.selectedType) {
      let obj = {
        report_typ: this.selectedType || 'D',
        dashboard_key: this.selectedDashboardKey ? this.selectedDashboardKey=='pare_dashboard'?this.dashboardKey:this.dashboardService.dashboardKey:this.dashboardService.dashboardKey,
        page_key: this.dashboardService.getPageKey[Number(this.tabId)]
      }
      this.formlyDynamicService.getCycleDate(method, url, parameter, data, obj).then((res: any) => {
        if (res != null) {
          res = res[0];
          
          if(!res) {
            res = {};
            res["from_dt"] = new Date("2017-03-01")
            res["to_dt"] = new Date()
          }

          // if(res) {
            // Set Min and Max Date
            this.minDate = new Date(res.from_dt);
            this.maxDate = new Date(res.to_dt)
            
            // this.minDate.setDate(this.minDate.getDate() - (this.templateOptions.selectedFromDate ?? 15));
     
            let dbDate = {
              start: this.minDate,
              end : this.maxDate
            }
            this.filterBadgeObj = {
              isRestriction: this.isRestriction,
              compulsaryFilter: this.compulsaryFilter,
              minDate:this.minDate,
              maxDate:this.maxDate ,
              }
            // Find Selected Value
            // let dbDate = this.formlyDynamicService.findSelectedDate(this.maxDate);
          
            if(!this.compulsaryFilter) {
              const date = this.formlyDynamicService.findAllSelectedDate(dbDate, false);
              this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
              this.filterService.allOptionData['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
            } else {
              const date = this.formlyDynamicService.findAllSelectedDate(dbDate, true);
              this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
              this.filterService.allOptionData['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
            }
    
            let fndData = false;
            let queryObj = this.queryFilterData || {};

            if(Object.keys(queryObj).length>0 && queryObj?.["carry_formly_date_filter"] && this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
              let dtObj = JSON.parse(queryObj?.["carry_formly_date_filter"]) || [];
              let fndObj = dtObj.find((f:any)=> f.key == this.fieldKey);
              if(fndObj && fndObj?.selected) {
                let obj = {start: moment(fndObj.start, 'MM-DD-YYYY').toDate() , end: moment(fndObj.end, 'MM-DD-YYYY').toDate()}
                dbDate = obj;
                const date = this.formlyDynamicService.findAllSelectedDate(dbDate, true);
                this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
                fndData = true;
              } else {
                fndData = false;
              }
            } else {
              // User State
              let userStateData: any = this.userActivityService.getData() 
              let updatesObj: any = Object.entries(userStateData.selectedFilters).map(([key, value]) => ({ key, value }));
              let findData: any = updatesObj.find((o: any) => o.key == this.fieldKey) 
              
              if (findData?.value) {
                if(findData?.value?.start!=null && findData?.value?.end!=null) {
                  findData.value["start"] = new Date(findData.value.start)
                  findData.value["end"] = new Date(findData.value.end)
                  dbDate = findData.value;
                  const date = this.formlyDynamicService.findAllSelectedDate(dbDate, true);
                  this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
                  fndData = true;
                } else {
                  fndData = false;
                }
              } else {
                fndData = false;
              }
            }
            
            if(!this.compulsaryFilter && !fndData) {
              const dbDates = {
                start: null,
                end: null
              }
              this.range.patchValue(dbDates);
              
              let formlyDb = this.formlyDynamicService.setFormlyFormValue(this.templateOptions, dbDates);
              this.field.formControl?.setValue(formlyDb);
  
              // Set Badges
              this.formlyDynamicService.setBadges(this.fieldKey, dbDates,this.filterBadgeObj);
            } else {
              this.range.patchValue(dbDate);
              
              // Set Values
              let formlyDb = this.formlyDynamicService.setFormlyFormValue(this.templateOptions, dbDate);        
              this.field.formControl?.setValue(formlyDb);
              
              // Set Badges
              this.formlyDynamicService.setBadges(this.fieldKey, dbDate,this.filterBadgeObj);
            }
          // }
        }
      })
    }
  }

  endDateChanges() {
    // debugger
    let selectedDate = this.range.value;
    if (selectedDate.start == null || selectedDate.end == null) return;
    
    // formly Model
    let formlyDb = this.formlyDynamicService.setFormlyFormValue(this.templateOptions, selectedDate);        
    this.field.formControl?.setValue(formlyDb);

    const date = this.formlyDynamicService.findAllSelectedDate(selectedDate, true);
    this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));

    let ab = { [this.fieldKey]: selectedDate }
    this.userActivityService.setData({ "selectedFilters": ab })

    if(this.mixPanelConfiguration) {
      let mixPanel = this.moduleName + ' - ' + this.dashboardService.dashboardName + ' - ' + this.label + ' - ' + 'Filter';
      this.mixpanelService.track(mixPanel);
    }

    // Set Badges
    this.formlyDynamicService.setBadges(this.fieldKey, selectedDate,this.filterBadgeObj);
  }

  compulsaryFilterValidation() {
    if(!this.compulsaryFilter && this.filterService?.allOptionData?.['formly_date']?.[this.fieldKey]?.start == this.filterService?.selectedItem?.['formly_date']?.[this.fieldKey]?.start &&
    this.filterService?.allOptionData?.['formly_date']?.[this.fieldKey]?.end == this.filterService?.selectedItem?.['formly_date']?.[this.fieldKey]?.end) {
      return false;
    } else {
      if(this.compulsaryFilter) {
        return false;
      } else {
        return true;
      }
    }
  }

  clearDateFilter() {
    const dbDates = {
      start: null,
      end: null
    }
    this.endDateChanges()

    this.range.patchValue(dbDates);
    
    
    let ab = { [this.fieldKey]: dbDates }
    this.userActivityService.setData({ "selectedFilters": ab })
   
    let formlyDb = this.formlyDynamicService.setFormlyFormValue(this.templateOptions, dbDates);
    this.field.formControl?.setValue(formlyDb);

    // Set Badges
    this.formlyDynamicService.setBadges(this.fieldKey, dbDates,this.filterBadgeObj);
    
    const date = this.formlyDynamicService.findAllSelectedDate(dbDates, false);
    this.filterService.selectedItem['formly_date'][this.fieldKey] = JSON.parse(JSON.stringify(date));
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
